<template>
  <v-banner class="primary white--text">
    <div class="d-flex align-center justify-center general-banner">
      <span class="white--text">{{ bannerText }}</span>
      <v-btn
        v-if="bannerLink"
        class="white--text ml-5"
        :color="whitelabel.colors.primary"
        outlined
        rounded
        depressed
        medium
        :to="bannerLink"
      >
        <span>{{ bannerLinkText }}</span>
      </v-btn>
      <v-btn
        v-if="isFunction"
        class="white--text ml-5"
        :color="whitelabel.colors.primary"
        outlined
        rounded
        depressed
        medium
        @click="callFunction"
      >
        <span>{{ bannerLinkText }}</span>
      </v-btn>
    </div>
  </v-banner>
</template>

<template>
  <v-banner
    class="general-banner"
    :class="{ 'mobile-banner-container': mobileBanner }"
  >
    <v-img
      :src="require('@/assets/shared/redesign/backgrounds/banner-pattern.svg')"
      cover
      class="banner-pattern"
    >
      <div
        v-if="bannerLink"
        class="d-flex align-center justify-center banner-text"
      >
        <span>
          {{ bannerText }}
          <router-link :to="bannerLink">
            <span class="banner-cta"> {{ bannerLinkText }} </span>
          </router-link>
        </span>
      </div>
      <div v-else class="d-flex align-center justify-center banner-text">
        <span>
          {{ bannerText }}
          <span class="banner-cta" @click="callFunction">
            {{ bannerLinkText }}
          </span>
        </span>
        <div>
          <span class="ml-1">or</span>
          <a
            v-if="isMobile"
            :href="`tel:${whitelabel.contactTelNumber}`"
            class="mobile-cta text-decoration-none"
          >
            {{ whitelabel.contactTelNumber }}
          </a>
          <span v-else class="desktop-cta">
            {{ whitelabel.contactTelNumber }}
          </span>
        </div>
      </div>
    </v-img>
  </v-banner>
</template>

<script>
export default {
  name: "GeneralBanner",
  data() {
    return {
      mobileBanner: false, //$vuetify.breakpoint.width <= 620 (keep if the text of the general banner ever becomes wordy again)
    };
  },
  props: {
    bannerText: {
      required: true,
      default: "",
      type: String,
    },
    bannerLink: {
      required: false,
      default: "",
      type: String,
    },
    bannerLinkText: {
      required: false,
      default: "",
      type: String,
    },
    isFunction: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  methods: {
    callFunction() {
      this.$emit("generalBannerFunction");
    },
    formatPhoneNumber(number) {
      // Remove all non-numeric characters
      return number.replace(/\D/g, "");
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice() || window.innerWidth <= 900;
    },
  },
};
</script>

<style lang="scss" scoped>
.general-banner {
  background-color: #1e1e1e !important;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .banner-text {
    color: white;
    height: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    padding: 0 16px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    .mobile-banner {
      display: block;
      word-break: break-word;
      overflow-wrap: break-word;
      max-width: 95dvw;
    }
  }

  .banner-cta {
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.4px;
    color: #50b848;
    padding-left: 5px;
    cursor: pointer;
  }

  .mobile-cta {
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.4px;
    color: #50b848;
    cursor: pointer;
  }

  .desktop-cta {
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.4px;
    color: #50b848;
  }

  .banner-pattern {
    height: 100%;
  }
}
.mobile-banner-container {
  height: auto !important;
}
</style>
